module.exports = __webpack_public_path__ + "img/electronic_electric_use.5147f58b.svg";